export default "__VITE_ASSET__Dd1LwSUa__"